import React from "react";
import { Snackbar, Alert, Button } from "@mui/material";

const severityStyles = {
  success: {
    bg: "#e6f9e6",
    border: "#a5d6a7",
    text: "#2e7d32",
    btn: "#4caf50",
    btnHover: "#43a047",
  },
  info: {
    bg: "#e6f3ff",
    border: "#90caf9",
    text: "#1565c0",
    btn: "#2196f3",
    btnHover: "#1976d2",
  },
  warning: {
    bg: "#fff8e1",
    border: "#ffecb3",
    text: "#f57c00",
    btn: "#ff9800",
    btnHover: "#fb8c00",
  },
  error: {
    bg: "#ffebee",
    border: "#ef9a9a",
    text: "#c62828",
    btn: "#f44336",
    btnHover: "#e53935",
  },
};

const CustomSnackbar = ({
  open,
  onClose,
  severity = "info",
  title,
  message,
  actionLabel = "Learn More",
  onActionClick,
  autoHideDuration = 3000,
  anchorOrigin = { vertical: "bottom", horizontal: "right" },
}) => {
  const style = severityStyles[severity];

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="outlined"
        sx={{
          width: "100%",
          borderRadius: "25px",
          backgroundColor: style.bg,
          border: `2px solid ${style.border}`,
          color: style.text,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          "& .MuiAlert-icon": { color: style.text },
          boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.3)",
          position: "relative",
          overflow: "hidden",
          animation: "heartbeat 2s infinite",
          // Moving border line effect
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            height: "3px",
            width: "100%",
            background: `linear-gradient(90deg, transparent, ${style.btn}, transparent)`,
            animation: "movingLine 3s linear infinite",
          },
          "@keyframes heartbeat": {
            "0%": {
              transform: "scale(1)",
              boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.3)"
            },
            "25%": {
              transform: "scale(1.05)",
              boxShadow: "0px 6px 20px 0px rgba(0, 0, 0, 0.4)"
            },
            "50%": {
              transform: "scale(1.1)",
              boxShadow: "0px 8px 24px 0px rgba(0, 0, 0, 0.5)"
            },
            "75%": {
              transform: "scale(1.05)",
              boxShadow: "0px 6px 20px 0px rgba(0, 0, 0, 0.4)"
            },
            "100%": {
              transform: "scale(1)",
              boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.3)"
            },
          },
        //   "@keyframes movingLine": {
        //     "0%": {
        //       transform: "translateX(-100%)",
        //       opacity: 0
        //     },
        //     "50%": {
        //       opacity: 1
        //     },
        //     "100%": {
        //       transform: "translateX(100%)",
        //       opacity: 0
        //     },
        //   },
        //   // Add pulse effect to the entire alert
        //   "&:hover": {
        //     animationDuration: "1.5s",
        //     "&::before": {
        //       animationDuration: "2s",
        //     },
        //   },
        }}
      >
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          flex: 1
        }}>
            {message && (
                <div style={{
                        fontSize: "0.7rem",
                        color: "#555",
                        animation: "fadeInOut 2s ease-in-out infinite"
                    }}>
                {message}
                </div>
            )}
            <div style={{
                fontSize: "0.8rem",
                animation: "pulse 1.5s ease-in-out infinite",
                "@keyframes pulse": {
                "0%": { opacity: 0.6 },
                "50%": { opacity: 1 },
                "100%": { opacity: 0.6 },
                },
            }}>
                {title && <strong>{title}</strong>}
            </div>
          
        </div>

        {/* {onActionClick && (
          <Button
            variant="contained"
            size="small"
            sx={{
              ml: 2,
              borderRadius: "20px",
              backgroundColor: style.btn,
              textTransform: "none",
              fontSize: "0.8rem",
              fontWeight: 600,
              px: 2,
              py: 0.5,
              minWidth: "auto",
              transition: "all 0.3s ease",
              animation: "bounce 2s infinite",
              "&:hover": {
                backgroundColor: style.btnHover,
                transform: "scale(1.05)",
                boxShadow: `0px 4px 12px ${style.btn}40`,
              },
              "@keyframes bounce": {
                "0%, 20%, 50%, 80%, 100%": { transform: "translateY(0)" },
                "40%": { transform: "translateY(-3px)" },
                "60%": { transform: "translateY(-1.5px)" },
              },
            }}
            onClick={onActionClick}
          >
            {actionLabel}
          </Button>
        )} */}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
